import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';

const THEME_LABELS = {
  dark: "Dark",
  light: "Light",
  pink: "Pink",
};

export default function ThemeToggle() {
  const { theme, setTheme, themes } = useTheme();
  const { language, setLanguage } = useLanguage();

  const nextLanguage = language === "tr" ? "en" : "tr";

  return (
    <div className="theme-controls">
      <div className="theme-selector" role="group" aria-label="Theme selector">
        {themes.map((themeName) => (
          <button
            key={themeName}
            className={`theme-option ${theme === themeName ? "active" : ""}`}
            onClick={() => setTheme(themeName)}
            type="button"
          >
            {THEME_LABELS[themeName]}
          </button>
        ))}
      </div>
      <button
        className="lang-option"
        onClick={() => setLanguage(nextLanguage)}
        type="button"
        aria-label="Language switcher"
      >
        {language === "tr" ? "TR 🇹🇷" : "EN 🇬🇧"}
      </button>
    </div>
  );
}
